import { RoomApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const roomSalesmanApi = {
  search: wrap(RoomApi, RoomApi.prototype.searchSalesman),
  create: wrap(RoomApi, RoomApi.prototype.addSalesman),
  show: wrap(RoomApi, RoomApi.prototype.showSalesman),
  update: wrap(RoomApi, RoomApi.prototype.updateSalesman),
};
